import partial from 'lodash/partial'

import {fsa, fsaPayloadByKeys} from '../helpers'
import {HELLO_BARS} from './enums'

export const ACTIVATE_HELLO_BAR = 'activate the hello bar'
export const activateHelloBar = fsaPayloadByKeys(ACTIVATE_HELLO_BAR, ['id', 'delay', 'campaignId'])

export const DEACTIVATE_HELLO_BAR = 'deactivate the hello bar'
export const deactivateHelloBar = fsa(DEACTIVATE_HELLO_BAR)

export const CLOSE_HELLO_BAR = 'close the hello bar'
export const closeHelloBar = fsa(CLOSE_HELLO_BAR)

export const OPEN_HELLO_BAR = 'open the hello bar'
export const openHelloBar = fsa(OPEN_HELLO_BAR)

// Specific Hello Bars

export const activateNewAccountHellobar = partial(activateHelloBar, HELLO_BARS.NEW_ACCOUNT)
export const activatePodcastHelloBar = partial(activateHelloBar, HELLO_BARS.PODCAST, ['campaignId'])
